import type { FaireProductEntity } from "../../entity_types/product";

export const p_gu5geaqc69: FaireProductEntity = {
  token: "p_gu5geaqc69",
  type: "product",
  name: "Goat Milk Caramel Farm Box | 6 Flavors | Retail",
  brandToken: "b_e17114db",
  brandName: "Big Picture Farm",
  imageUrl: "https://cdn.faire.com/fastly/a92cca197bee3b9fcabfb5d2176e00636a53fddac99eef5465f65b4ab6a366cb.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/83f4e7ef5d8efc63578cb1226cb4ec4ee50d470999ea0734a2b79e3415231a74.png",
    "https://cdn.faire.com/fastly/d8cb3e77df0eb7b405386d39b6dddc9008e2559b9325977e02ebc292c4329370.png",
    "https://cdn.faire.com/fastly/5712c03343bbf22d658036db7e944eb33f43881f0990253b4bcbcc0d1f89a784.png",
    "https://cdn.faire.com/fastly/4a5d45284ce152a60677f3777911a7b868107f9d2a24d1403047db32d32d02ed.png",
    "https://cdn.faire.com/fastly/4006cb9f67fb4e0c84299b97aa9fada40ba1287fd844d84593d720f017b172fc.png",
    "https://cdn.faire.com/fastly/c1bc502309776edc3b3dd463da6b9cf0aac2a374a33e10baf907906c2919025e.png"
  ],
  priceDollars: 7.75,
  description: " ***'Best By' stickers will read 10-11 weeks from the ship-date\n\nOur signature farm box is one of the most awarded confections in America — a Fancy Food Show gold SOFI winner and a Good Food Award recipient. Each box holds 11 caramels (3.2 oz) in your choice of six distinct flavors: Sea Salt & Bourbon Vanilla, Brown Butter Bourbon, Chai, Maple Cream, Cocoa Latte, and Raspberry Rhubarb. Illustrated with Louisa Conrad's original line drawings of our goats, these boxes fly off retail shelves and make a genuinely memorable corporate gift. Vermont-made, grass-fed, non-GMO.\n",
  tags: [],
  msrpDollars: 15.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-14T17:06:56.502Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
